<!--
  File name: PassReset.vue
  Program Description:
    - This component contains the means to request for a password reset.
  Includes:\
    - Forgot password functionality
    - Navigation to Login page
-->
<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="5"
          >
            <v-card
              class="elevation-12 px-5 pt-6 pb-12 rounded-lg"
              tile
            >
              <v-card-title
                class="title"
              >
                <h1 class="primary--text text-h3 font-weight-bold">
                  Forgot Password?
                </h1>
              </v-card-title>
              <p class="font-weight-bold text-subtitle-2 ml-5">
                Don't worry, we got your back!
              </p>
              <v-card-subtitle class="py-5 gray--text text-subtitle-2">
                <p>Enter the email address you're using for your account and we will send you a password reset link.</p>
              </v-card-subtitle>
              <v-card-text>
                <v-form
                  @submit.prevent
                >
                  <v-text-field
                    id="otp-field"
                    v-model.trim="email"
                    label="Email"
                    outlined
                    :error-messages="genericError('email', 'Email')"
                    @input="$v.email.$touch()"
                    @keyup.enter="submit"
                    @blur="$v.email.$touch()"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions class="d-flex flex-column">
                <v-btn
                  block
                  class="py-6"
                  color="primary"
                  :loading="$data.$meta.loading"
                  @click="submit"
                >
                  Continue
                </v-btn>
                <v-spacer />
                <v-btn
                  class="py-6 primary--text font-weight-bold"
                  text
                  @click="$router.go(-1)"
                >
                  Back to Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { validationMixin, custom, validationErrors } from '@/utils/validations'
import { metaMixin } from '@/meta'
import password from '@/utils/webapi/password'

export default {
  name: 'PassReset',
  mixins: [validationMixin, metaMixin],
  data: () => ({
    email: '',
    $meta: {
      loading: false
    }
  }),
  validations: {
    email: custom.emails
  },
  computed: {
    ...validationErrors
  },
  methods: {
    // submit request password reset to specified email
    async submit () {
      const { $meta } = this.$data
      this.$v.$touch()
      if (!this.$v.$invalid) {
        $meta.loading = true
        const resp = await password.request.reset(this.email)
        resp && ($meta.loading = false)
        if (resp.ok) {
          this.$store.dispatch('showAlert', {
            message: $meta.forms.passReset.success,
            type: 'clock',
            email: this.email
          })
        } else {
          this.$store.dispatch('showAlert', {
            message: (await resp.json()).error,
            type: 'error'
          })
        }
      }
    }
  }
}
</script>
